import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/center/faqs";

export const faqs = {
    // ...example,
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
}
